
import $ from 'jquery';
import './../search/FactfinderTracking.js';
import {getMetaContent} from "./Util";

const dataLayer = window.dataLayer = window.dataLayer || [];
const listing = window.listing = window.listing || {
	impressions: [],
};

window.sendImpressions = function() {
	const chunkSize = 32;
	for ( let i = 0; i < listing.impressions.length; i += chunkSize ) {
		dataLayer.push( {
			'event': 'productImpression',
			'ecommerce': {
				'currencyCode': getMetaContent( '_isoCurrency' ) || 'EUR',
				'impressions': listing.impressions.slice( i, i + chunkSize )
			}
		} );
	}
};

$( document ).ready( function() {

	// Send Listing Impressions, when ready.
	if ( listing && listing.impressions.length > 0 ) {
		window.sendImpressions();
	}
} );

$( document ).ready( function() {
	$( '.notification--track' ).each( function(){

		var dataLayer = window.dataLayer = window.dataLayer || [];
		dataLayer.push( {
			"event": "gtmMsgLayer",
			"gtmMsgLayerText": $( this ).text(),
			"gtmMsgLayerPlacement": $( this ).data( 'position' ), // or "cart" or sth. else
			"gtmMsgLayerCode": $( this ).data( 'errorcode' ), // if there are different types of errors and we want to rely on the number instead of (maybe translated) text
			"gtmMsgLayerType": "error" // maybe there can also be warnings, info messages, etc.?
		} );
	} )
} );

//product added to basket from detail page and quickview
$( document ).on( 'click', 'div.article_submit_wrapper span.success_indicator, article.mdl_popup span.success_indicator', function() {
	var holder = $( this ).closest( '.article_submit_wrapper, .content_wrapper' );

	var quickBuy = $( this ).hasClass( 'trigger_quick_buy' );

	if ( quickBuy ) {
		dataLayer.push( {
			'event': 'addToCart',
			'shopLayer': "quickview_popup",
			'ecommerce': {
				'currencyCode': $( "meta[name='_isoCurrency']" ).attr( 'content' ),
				'add': {
					'products': [{
						'id': holder.data( 'eec-id' ),
						'name': holder.data( 'eec-name' ),
						'price': holder.data( 'eec-price' ) && parseFloat( holder.data( 'eec-price' ).toString().replace( ',', '.' ) ),
						'brand': holder.data( 'eec-brand' ),
						'variant': $( 'input.article_color[type=radio]:checked' ).val(),
						'dimension10': holder.data( 'eec-oxid' ),
						'dimension11': holder.data( 'eec-ean' ),
						'category': holder.data( 'eec-category' ),
						'quantity': holder.data( 'eec-quantity' )
					}]
				}
			}
		} );
	} else {
		dataLayer.push( {
			'event': 'addToCart',
			'ecommerce': {
				'currencyCode': $( "meta[name='_isoCurrency']" ).attr( 'content' ),
				'add': {
					'products': [{
						'id': holder.data( 'eec-id' ),
						'name': holder.data( 'eec-name' ),
						'price': holder.data( 'eec-price' ) && parseFloat( holder.data( 'eec-price' ).toString().replace( ',', '.' ) ),
						'brand': holder.data( 'eec-brand' ),
						'variant': $( 'input.article_color[type=radio]:checked' ).val(),
						'dimension10': holder.data( 'eec-oxid' ),
						'dimension11': holder.data( 'eec-ean' ),
						'category': holder.data( 'eec-category' ),
						'quantity': holder.data( 'eec-quantity' )
					}]
				}
			}
		} );
	}
} );

//product deleted from cart
$( document ).on( 'click', '.mdl_article_item__remove', function() {
	dataLayer.push( {
		'event': 'removeFromCart',
		'ecommerce': {
			'remove': {
				'products': [{
					'id': $( this ).data( 'eec-id' ),
					'name': $( this ).data( 'eec-name' ),
					'price': $( this ).data( 'eec-price' ),
					'brand': $( this ).data( 'eec-brand' ),
					'variant': $( this ).data( 'eec-variant' ),
					'category': $( this ).data( 'eec-category' ),
					'dimension10': $( this ).data( 'eec-oxid' ),
					'quantity': $( this ).data( 'eec-quantity' )
				}]
			}
		}
	} );
} );

//"next" on shipping method select
$( document ).on( 'submit', 'form.form-horizontal.form-user-shipping', function() {
	const $input = $( 'input[name="invadr[oxuser__marketpreferedshippingflag]"]:checked' );
	const option = $input.data( 'eec-title' );
	dataLayer.push( {
		'event': 'checkoutOption',
		'ecommerce': {
			'checkout_option': {
				'actionField': {
					'step': 2,
					'option': option
				}
			}
		}
	} );
} );

//"next" on payment method select
$( document ).on( 'submit', 'form.form-horizontal.form-user-payment', function() {
	const $input = $( 'input[name="paymentid"]:checked' );
	const option = ( () => {
		// is not Click&Collect?
		if ( $input.length == 1 ) {
			return $input.data( 'eec-title' );
		} else {
			if ( $( 'input[name="paymentid"]' ).length == 1 ) {
				if (  $( 'input[name="paymentid"]' ).val() == '' ) {
					return 'Click&Collect';
				}
			}
		}
	} )();

	dataLayer.push( {
		'event': 'checkoutOption',
		'ecommerce': {
			'checkout_option': {
				'actionField': {
					'step': 3,
					'option': option
				}
			}
		}
	} );
} );
